import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CONTENT: {
    RATE_CONTENT: (contentId, rating) => ({ contentId, rating }),
    API: {
      RATE_CONTENT: apiResourceActionCreator('contentRating')
    }
  }
});

export const apiAction = (authToken, contentId, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/${contentId}/rating`, authToken, payload, action.content.api.rateContent)

export function* rateContent(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.contentId, action.payload.rating))
}

const configuration = {
  name: 'rateContent',
  action: action,
  sagas: rateContent,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      contentRating: action.payload.contentRating,
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/content/configurations/rateContent.js